export function numberAsCurrency(num: number | bigint) {
  return new Intl.NumberFormat('us-EN', {
    style: 'currency',
    currency: 'USD',
  }).format(num);
}

export function numberAsCurrencyWholeNum(num: number | bigint) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(num);
}

export const splitPrice = (price: number = 0) => {
  if (price === 0) {
    return { dollars: '0', cents: '' };
  }
  const formattedPrice = price.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const priceArr = formattedPrice.match(/(\d|,)+/g);

  const dollars = priceArr?.[0] ?? '0';
  const cents = priceArr?.[1] ?? '00';

  return { dollars, cents };
};
